import {
  defaultCardWithContent,
  defaultCardWithText,
  defaultMobileCard,
} from "src/components/shared/Cards/sharedStyles";
import styled, { css } from "styled-components";

export const SummaryCardElement = styled.div<{ isGreatest?: boolean }>`
  ${defaultMobileCard}
  ${defaultCardWithContent}
  ${defaultCardWithText}

  margin-top: 8px;

  border: ${({ theme }) => theme.border.thin} solid
    ${({ theme }) => theme.colors.cards.borders.secondary};

  font-size: ${({ theme }) => theme.fonts.sizes.xxs};

  font-size: ${({ theme }) => theme.fonts.sizes.base};
  border-radius: 4px 4px 0px 4px;

  ${({ isGreatest, theme }) =>
    isGreatest &&
    css`
      border-color: ${theme.colors.cards.borders.summary};
    `}
`;

export const SummaryBarWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 168px;
  align-items: flex-end;
`;

export const SummaryBar = styled.div<{
  percentage: number;
  isGreatest?: boolean;
}>`
  display: block;
  width: 100%;
  height: 6px;
  background-color: ${({ theme }) => theme.colors.cards.fills.summaryBarBg};
  border-radius: 0px 2px 2px 0px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 0px 2px 2px 0px;
    width: ${({ percentage }) => `${percentage}%`};
    background-color: ${({ theme, isGreatest }) =>
      isGreatest
        ? theme.colors.cards.fills.picked
        : theme.colors.cards.fills.summaryBar};
  }
`;
